<template>
  <div class="grid grid-cols-1 mx-5 my-5 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-3 gap-6">

    <BoardCard title="Log token">
      <TokenBlock></TokenBlock>
    </BoardCard>

    <BoardCard title="Управление событиями">
      <p class="text-gray-300 mb-4">Функционал в разработке</p>
<!--      <p class="text-gray-600 mb-2">Создание соыбтия по логам: 30м</p>
      <p class="text-gray-600 mb-2">Минимальный уровень: error</p>
      <p class="text-gray-600 mb-2">Ожидание восстановления: 2м</p>-->
      <button class="px-4 py-2 mt-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors">
        Настроить
      </button>
    </BoardCard>

    <BoardCard title="Тариф">
      <TariffBlock></TariffBlock>
    </BoardCard>
    <BoardCard title="Demo Data">
      <DemoDataBlock></DemoDataBlock>
    </BoardCard>

    <!-- Ячейка 4 -->
    <BoardCard title="Health Check token">
      <p class="text-gray-600 mb-4">Не создано</p>
      <p class="text-gray-300 mb-4">Функционал в разработке</p>
      <button class="px-4 py-2 mt-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors">
        Сменить
      </button>
    </BoardCard>
  </div>
</template>

<script>
import TokenBlock from "@/components/block/TokenBlock.vue";
import TariffBlock from "@/components/block/TariffBlock.vue";
import DemoDataBlock from "@/components/block/DemoDataBlock.vue";
import BoardCard from "@/components/BoardCard.vue";

export default {
  name: 'SettingsPage',
  components: {TokenBlock, DemoDataBlock, TariffBlock, BoardCard},
  data() {
    return {
      modalOpen: false
    }
  },
  methods: {
    closeModal: function () {
      this.modalOpen = false;
    },
    openModal: function () {
      this.modalOpen = true;
    }
  }
}
</script>

<style scoped>

</style>